// extracted by mini-css-extract-plugin
export default {"seatsWrap":"cinemaSeats_seatsWrap__w7VD-","seats":"cinemaSeats_seats__9v5a3","rows":"cinemaSeats_rows__llUE+"};